import EstadosForm from '../../../components/ui/Cajero/EstadosComponents/FormEstados';

const EstadosUI = () => {
  return (
    <div className="pb-4">
      <EstadosForm />
    </div>
  );
};

export default EstadosUI;
